'use client';
import CDNImage from '@/components/cdnImage/cdnImage';
import { pxToVw } from '@/components/productCard/common/utils';
import { ProductType } from '@/components/productCard/index.interface';
import { useStores } from '@/models';
import { getExposureRecord, sendClickTrack } from '../../tempo_track';
import ProductCard from '@/components/productCard';
import style from './style.module.scss';

type Props = {
  moduleData: any;
  localInfo: any;
  pageCode: string;
  floorIndex: number;
};

const adaptiveStyle = {
  bgImageWidth: pxToVw(375),
  bgImageHeight: pxToVw(294),
  productListTop: pxToVw(72),
  productCardWidth: pxToVw(124),
  productCardHeight: pxToVw(214),
  skuImgWidth: pxToVw(124),
  skuImgHeight: pxToVw(124),
  gap: pxToVw(8),
};

export default function Module(props: Props) {
  const { moduleData, localInfo, pageCode, floorIndex } = props;

  // 初始化页面配置对象
  const pageConfig: any = {};
  // @ts-ignore
  const { cartNumStore } = useStores();
  // 配置初始化函数，解析模块数据
  const initConfig = (moduleData: any) => {
    // 从模块数据中提取产品池数据
    pageConfig.data = moduleData.dataBatch?.productPool[0].productPool || [];
    // 提取背景图片配置
    pageConfig.backgroundImg = moduleData.dataBatch?.productPool[0].backgroundImg || {};
  };
  initConfig(moduleData);
  if (!Array.isArray(pageConfig.data) || pageConfig.data.length === 0) {
    return null;
  }

  const getCartNum = () => {
    cartNumStore.fetchCartNum(true);
  };
  const exposureRecord = getExposureRecord(pageCode);

  const genEventTrackingInfo = (product: any, index: number) => {
    const eventTrackingInfo = {} as { [key: string]: any };
    const json_param = {
      skuid: product.skuId,
      index: index,
      pos: floorIndex,
      page_id: 'cms_' + pageCode,
      moduleInstanceId: 'up-horizontal-product-big',
      propoolid: product.productPoolId,
      algo_rd_inf: product.algoRdInfo || '',
      broker_info: product.brokerInfo ? JSON.stringify(product.brokerInfo) : '',
    };

    // 元素露出50%停留300ms触发
    const expConfig = {
      useClick: false,
      stay_duration: 0.3,
      repeated: false,
      area_rate: 0.5,
    };

    eventTrackingInfo['productClickPoint'] = () =>
      sendClickTrack.cms_TempoPage_UpHorizontalProductPoolBig_Click(json_param);
    eventTrackingInfo['productExpConfig'] = {
      event_id: exposureRecord.cms_TempoPage_UpHorizontalProductPoolBig_Expo,
      config: expConfig,
      json_param: json_param,
    };
    eventTrackingInfo['cartClickPoint'] = () =>
      sendClickTrack.cms_TempoPage_UpHorizontalPageBig_Addtocart_Click(json_param);
    return eventTrackingInfo;
  };

  return (
    <div className={style['up-horizontal-product-big']}>
      <CDNImage
        // @ts-ignore
        src={pageConfig.backgroundImg.imageUrl}
        width={pageConfig.backgroundImg.imageWidth}
        height={pageConfig.backgroundImg.imageHeight}
        style={{
          width: adaptiveStyle.bgImageWidth,
          height: adaptiveStyle.bgImageHeight,
          objectFit: 'cover',
          objectPosition: 'top',
        }}
      />
      <div
        className={style.productScrollContainer}
        style={{
          top: adaptiveStyle.productListTop,
          left: '0px',
          right: '0px',
          position: 'absolute',
        }}
      >
        <div
          className={style.productList}
          style={{
            paddingLeft: adaptiveStyle.gap,
            //  最后一个元素需要有间隔，使用margin-right
            //  gap: adaptiveStyle.gap
          }}
        >
          {pageConfig.data.length
            ? pageConfig.data.map((item: any, index: number) => {
                const productData = {
                  type: ProductType.TYPE_1,
                  width: adaptiveStyle.productCardWidth,
                  height: adaptiveStyle.productCardHeight,
                  skuName: item.skuName,
                  shouldShowSkuName: true,
                  skuId: item.skuId,
                  realPrice: item.realPrice,
                  originalPrice: item?.originalPriceV2,
                  originalPriceTips: item?.originalPriceDesc,
                  currency: localInfo?.currencyCode || '',
                  languageCode: localInfo?.languageCode || '',
                  cartChange: getCartNum,
                  shouldShowCart: true,
                  trackingPointParams: genEventTrackingInfo(item, index),
                  // style
                  containerStyle: {
                    backgroundColor: '#fff',
                    marginRight: adaptiveStyle.gap,
                  },
                  skuImgKeyParams: {
                    imgUrlKey: item?.imageUrl,
                    width: 200,
                    height: 200,
                  },
                  skuImgStyle: {
                    width: adaptiveStyle.skuImgWidth,
                    height: adaptiveStyle.skuImgHeight,
                    borderRadius: '4px',
                    alignSelf: 'center',
                  },
                  skuNameStyle: {
                    display: '-webkit-box',
                    whiteSpace: 'normal',
                    height: '36px',
                    marginTop: '-6px',
                    WebkitBoxOrient: 'vertical' as const,
                    WebkitLineClamp: 2,
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    color: '#1a1a1a',
                    wordBreak: 'break-all' as const,
                    paddingLeft: '8px',
                    paddingRight: '8px',
                  },
                  priceStyle: {
                    fontSize: '12px',
                  },
                  priceAndCartStyle: {
                    paddingLeft: '8px',
                    paddingRight: '8px',
                  },
                  realPriceJDIPriceParams: {
                    symbolStyle: { fontSize: '14px' },
                    integerStyle: { fontSize: '18px' },
                    decimalPointStyle: { fontSize: '18px' },
                    decimalPlaceStyle: { fontSize: '18px' },
                    containerStyle: {
                      display: 'block',
                      height: '20px',
                      lineHeight: '20px',
                      fontWeight: '700',
                      color: '#1a1a1a',
                      marginBottom: '2px',
                    },
                  },
                  originalPriceJDIPriceParams: {
                    containerStyle: {
                      height: '12px',
                      fontWeight: '500',
                      lineHeight: '12px',
                      color: '#888b94',
                    },
                  },
                  cartIconColor: 'black',
                  cartIconStyle: {
                    width: '24px',
                    height: '24px',
                  },
                };
                return <ProductCard key={index} productData={productData} />;
              })
            : null}
        </div>
      </div>
    </div>
  );
}
